import axios from "../../../axios";

export const GET_USER = 'GET_USER';

export const getUser = () => (dispatch) => {
    axios.get('/auth/profile').then((res) => {
        dispatch({
            type: GET_USER,
            payload: {
                user: res.data
            },
        });
    });
};
